import { Typography } from '@cmg/design-system';

export const LimitIndicationsOnlyNote: React.FC = () => {
  return (
    <Typography variant="body2">
      <Typography variant="subtitle2" component="span">
        Note:{' '}
      </Typography>
      This offering allows Limit Indications only.
    </Typography>
  );
};
